
import React, { FC, Suspense } from "react";
import styles from "./Carousel.module.css";
import classNames from "classnames";
import { Loading } from "components/atoms";
import { TIntroSlide, TVideoItem } from "types";

const LazyVideoCarouselDesktop = React.lazy(() => import('./components/Desktop/CarouselDesktop').then((module) => ({
  default: module.VideoCarouselDesktop
})))

const LazyVideoCarouselMobile = React.lazy(() => import('./components/Mobile/CarouselMobile').then((module) => ({
  default: module.VideoCarouselMobile
})))

type TVideoCarouselProps = {
  Duration: number;
  VideosLinkPool: TVideoItem[];
  HeadingSuperscript: string;
  HeadingLarge: string;
  Description: string;
  isDesktop: boolean;
  className?: string;
};

const _VideoCarousel: FC<TVideoCarouselProps> = ({
  Duration = 5,
  VideosLinkPool,
  HeadingSuperscript,
  HeadingLarge,
  Description,
  isDesktop,
  className
}) => {

  const introSlide: TIntroSlide = {
    Title: HeadingSuperscript,
    Subtitle: HeadingLarge,
    Description: Description,
    IntroSlide: true
  };

  const _VideosLinkPool = VideosLinkPool.slice(0, 10);

  return (
    <section className={classNames(styles.wrapper, "animateonscroll")}>
      {
        isDesktop
          ?
          <Suspense fallback={< Loading />}>
            <LazyVideoCarouselDesktop
              Duration={Duration}
              introSlide={introSlide}
              VideoLinkPool={_VideosLinkPool}
              className={className}
            />
          </Suspense>
          :
          <>
            <Suspense fallback={< Loading />}>
              <LazyVideoCarouselMobile
                 HeadingSuperscript={HeadingSuperscript}
                 HeadingLarge={HeadingLarge}
                 Description={Description}
                 VideosLinkPool={_VideosLinkPool}
                 className={className}
              />
            </Suspense>
          </>
      }
    </section>
  );
};

export const VideoCarousel = React.memo(_VideoCarousel);
